/**
 * Returns a new array with the items of `array` in random order, using the
 * Fisher-Yates shuffle. Does not mutate the input array.
 */
export const shuffleArray = (array) => {
  const result = [...array];

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
};
